import React, { useEffect, useState } from 'react'
import { movieCheckboxActions, movieCheckboxesData, personCheckboxActions, personCheckboxesData } from '../Data/StaticPersonandMoviedata'

const Checkbox = ({ label, propertyName, checked, onChange }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
      <label style={{ margin: '0', marginRight: '8px' }}>{label}:</label>
      <input
        type='checkbox'
        id={propertyName}
        value={propertyName}
        checked={checked}
        onChange={onChange}
        style={{ margin: '0' }}
      />
    </div>
)

const GoatAndPopular = props => {
  const { inputData, sendInputData, sendBooleanValueChangeDone, Popular, GOAT, originalLanguageTelugu, type } = props

  const checkboxesData = type === 'person' ? personCheckboxesData : movieCheckboxesData
  const checkboxActions = type === 'person' ? personCheckboxActions : movieCheckboxActions
  const initialCheckboxState = checkboxesData.reduce((checkboxState, { propertyName }) => {
    checkboxState[propertyName] = inputData?.[propertyName] || false
    return checkboxState
  }, {})
  const [checkboxes, setCheckboxes] = useState(initialCheckboxState)

  const handleCheckboxChange = propertyName => event => {
    const updatedCheckboxes = { ...checkboxes, [propertyName]: event.target.checked }
    setCheckboxes(updatedCheckboxes)

    const updatedInputData = { ...inputData, [propertyName]: event.target.checked }
    sendInputData(updatedInputData)
    const actionKey = checkboxActions[propertyName]

    if (actionKey) {
      sendBooleanValueChangeDone(actionKey, true)
    }
  }

  useEffect(() => {
    setCheckboxes(
      checkboxesData.reduce((checkboxState, { propertyName }) => {
        checkboxState[propertyName] = inputData?.[propertyName] || false
        return checkboxState
      }, {}),
    )
  }, [Popular, GOAT, originalLanguageTelugu])

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '20px' }}>
      {checkboxesData.map(({ label, propertyName }) => (
        <Checkbox
          key={propertyName}
          label={label}
          propertyName={propertyName}
          checked={checkboxes[propertyName]}
          onChange={handleCheckboxChange(propertyName)}
        />
      ))}
    </div>
  )
}

export default GoatAndPopular
